var map = {
	"./Andrea McLeod-Karim.jpg": 1088,
	"./Anjan Sahu.jpg": 1089,
	"./Manohara Raj Karuppasamy.png": 1090,
	"./Michael O’Sullivan UCC.jpg": 1091,
	"./Mrs Nair.png": 1092,
	"./Nicholas Venn Springfield College.jpg": 1093,
	"./Pratik-giri.jpg": 1094,
	"./Praveen raval.57a24d7.jpg": 1095,
	"./Praveen raval.jpg": 1096,
	"./Rylan James.jpg": 1097,
	"./Shahina Khaitri.jpg": 1098,
	"./anjan.jpg": 1099,
	"./asif.png": 1100,
	"./avtar-1.png": 1101,
	"./fair-1.png": 1102,
	"./fair-2.png": 1103,
	"./fair-3.png": 1104,
	"./fair-4.png": 1105,
	"./fair-5.png": 1106,
	"./fair-6.png": 1107,
	"./img-1.png": 1108,
	"./mahonaraj.png": 1109,
	"./mehoonri.jpg": 1110,
	"./rylan.jpg": 1111,
	"./sandeep.jpg": 1112,
	"./seeneen mulla.jpg": 1113,
	"./shahnia.jpg": 1114,
	"./siddhi.jpg": 1115,
	"./sinjo.jpg": 1116,
	"./sonia.jpg": 1117
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 336;


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/testimonial ^\.\/.*$
// module id = 336
// module chunks = 1